const inputFields = [
  {
    name: "code",
    type: "text ",
    label: "Code",
  },

  {
    name: "discountType",
    type: "select",
    label: "Discount Type",
    placeholder: "",
    options: [
      {
        value: "percentage",
        label: "Percentage",
      },
      {
        value: "fixed",
        label: "Fixed Amount",
      },
    ],
  },
  {
    name: "discountValue",
    type: "number",
    label: "Discount",
  },
  {
    name: "validityDays",
    type: "number",
    label: "Validity (in days)",
  },
  {
    name: "maxUsage",
    type: "number",
    label: "Max Usage",
  },
  {
    name: "status",
    type: "select",
    label: "Status",
    placeholder: "",
    options: [
      {
        value: "active",
        label: "Active",
      },
      {
        value: "inactive",
        label: "Inactive",
      },
    ],
  },
  {
    name: "expiry",
    type: "number",
    label: "Expiry (in days)",
  },
];

export default inputFields;
